import { Button } from 'antd'
import { Sale } from 'src/core/models'
import { useAppSelector } from 'src/app/hooks'
import { currencyListSelector } from 'src/features'
import styles from './DownloadCsvButton.module.scss'
import { CloudDownloadOutlined } from '@ant-design/icons'
import { downloadSaleCsvFile, showNotification } from 'src/core/helpers'

interface PropsType {
  sales: Sale[]
  labelError: string
  labelButton: string
}

const DownloadCsvButton = (props: PropsType) => {
  const { sales, labelError, labelButton } = props
  const currencyList = useAppSelector(currencyListSelector)

  const handleClick = () => {
    if (sales.length === 0) {
      showNotification('error', labelError)
      return
    }
    downloadSaleCsvFile(sales, currencyList)
  }

  return (
    <Button
      icon={<CloudDownloadOutlined />}
      className={styles['button']}
      onClick={handleClick}
    >
      {labelButton}
    </Button>
  )
}

export default DownloadCsvButton
